const SlideImgManage = () => import("@/pages/content-manage/SlideImgManage");
const HandleSlideImg = () => import("@/pages/content-manage/HandleSlideImg");
const CaseManage = () => import("@/pages/content-manage/CaseManage");
const ProductAnalysis = () => import("@/pages/content-manage/ProductAnalysis");
const ArticleManage = () => import("@/pages/content-manage/ArticleManage");
const ClientManage = () => import("@/pages/content-manage/ClientManage");
const CooperateConsult = () =>
  import("@/pages/content-manage/CooperateConsult");
const IndustryCategory = () =>
  import("@/pages/content-manage/IndustryCategory");
const CaseHandle = () => import("@/pages/content-manage/CaseHandle");
const ProductanalysisHandle = () =>
  import("@/pages/content-manage/ProductanalysisHandle");
const ArticleCategory = () => import("@/pages/content-manage/ArticleCategory");
const ArticleLabel = () => import("@/pages/content-manage/ArticleLabel");
const ArticleHandle = () => import("@/pages/content-manage/ArticleHandle");
const ClientHandle = () => import("@/pages/content-manage/ClientHandle");
const ServiceManage = () => import("@/pages/content-manage/ServiceManage");
const ServiceHandle = () => import("@/pages/content-manage/ServiceHandle");
const FriendlyLink = () => import("@/pages/content-manage/FriendlyLink");
const TdkManage = () => import("@/pages/content-manage/TdkManage");
const TdkHandle = () => import("@/pages/content-manage/TdkHandle");

export default [
  {
    path: "/slideimg-manage",
    component: SlideImgManage,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "轮播图管理",
        url: "",
      },
    ],
  },
  {
    path: "/slideimg-manage/add-slide-img",
    component: HandleSlideImg,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "轮播图管理",
        url: "",
      },
      {
        name: "添加轮播图",
        url: "",
      },
    ],
  },
  {
    path: "/slideimg-manage/edit-slide-img",
    component: HandleSlideImg,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "轮播图管理",
        url: "",
      },
      {
        name: "编辑轮播图",
        url: "",
      },
    ],
  },
  {
    path: "/casemanage",
    component: CaseManage,
    meta: [
      {
        name: "案例管理",
        url: "",
      },
      {
        name: "案例列表",
        url: "",
      },
    ],
  },
  {
    path: "/industry-category",
    component: IndustryCategory,
    meta: [
      {
        name: "案例管理",
        url: "",
      },
      {
        name: "案例列表",
        url: "/casemanage",
      },
      {
        name: "行业分类",
        url: "",
      },
    ],
  },
  {
    path: "/case-handle",
    component: CaseHandle,
    meta: [
      {
        name: "案例管理",
        url: "",
      },
      {
        name: "案例列表",
        url: "/casemanage",
      },
      {
        name: "添加案例",
        url: "",
      },
    ],
  },
  {
    path: "/productanalysis",
    component: ProductAnalysis,
    meta: [
      {
        name: "产品解析",
        url: "",
      },
      {
        name: "解析列表",
        url: "",
      },
    ],
  },
  {
    path: "/productanalysishandle",
    component: ProductanalysisHandle,
    meta: [
      {
        name: "产品解析",
        url: "/productanalysis",
      },
      {
        name: "解析列表-添加",
        url: "",
      },
    ],
  },
  {
    path: "/articlecategory",
    component: ArticleCategory,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "文章资讯",
        url: "/articlemanage",
      },
      {
        name: "文章分类",
        url: "",
      },
    ],
  },
  {
    path: "/articlelabel",
    component: ArticleLabel,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "文章资讯",
        url: "/articlemanage",
      },
      {
        name: "文章标签",
        url: "",
      },
    ],
  },
  {
    path: "/articlehandle",
    component: ArticleHandle,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "文章资讯",
        url: "/articlemanage",
      },
      {
        name: "添加文章",
        url: "",
      },
    ],
  },
  {
    path: "/articlemanage",
    component: ArticleManage,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "文章资讯",
        url: "",
      },
      {
        name: "文章列表",
        url: "",
      },
    ],
  },
  {
    path: "/clientmanage",
    component: ClientManage,
    meta: [
      {
        name: "合作伙伴管理",
        url: "",
      },
      {
        name: "合作伙伴列表",
        url: "",
      },
    ],
  },
  {
    path: "/clienthandle",
    component: ClientHandle,
    meta: [
      {
        name: "合作伙伴管理",
        url: "",
      },
      {
        name: "合作伙伴列表",
        url: "",
      },
      {
        name: "添加/编辑合作伙伴",
        url: "",
      },
    ],
  },
  {
    path: "/cooperateconsult",
    component: CooperateConsult,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "合作咨询",
        url: "",
      },
    ],
  },
  {
    path: "/service-mange",
    component: ServiceManage,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "首页服务管理",
        url: "",
      },
    ],
  },
  {
    path: "/service-handle",
    component: ServiceHandle,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "首页服务管理",
        url: "/service-mange",
      },
      {
        name: "编辑服务",
      },
    ],
  },
  {
    path: "/friendly-link",
    component: FriendlyLink,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "友情链接管理",
        url: "",
      },
    ],
  },
  {
    path: "/tdk-mange",
    component: TdkManage,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "tdk设置",
        url: "",
      },
    ],
  },
  {
    path: "/tdk-handle",
    component: TdkHandle,
    meta: [
      {
        name: "内容管理",
        url: "",
      },
      {
        name: "tdk设置",
        url: "/tdk-mange",
      },
      {
        name: "编辑tdk",
      },
    ],
  },
];
